import React, { useState } from "react";
import { Popconfirm, Button, message, Space, Input } from "antd";
import Service, { ElAdminEventLogService } from "../services";

const UpdateLeverageButton = ({ actionDetails }) => {
  const { exchange: exchangeInstrument, account, symbol: pair, leverage: currentLeverage, sessionName } = actionDetails;
  const [targetLeverage, setTargetLeverage] = useState(currentLeverage);

  const onTargetLeverageChange = ({ target: { value } }) => {
    setTargetLeverage(value);
  };

  return (
    <Space>
      <Popconfirm
        title={
          <>
            <p>Update leverage</p>
            <Input
              style={{ marginLeft: -15 }}
              type="number"
              value={targetLeverage}
              onChange={onTargetLeverageChange}
              max="20"
              min="1"
              placeholder="leverage"
            ></Input>
          </>
        }
        onConfirm={async () => {
          const hideLoading = message.loading("Updating...", 0);
          try {
            const setLeverageResult = await Service.setLeverage({
              exchangeInstrument,
              account,
              pair,
              leverage: targetLeverage,
              sessionName,
            });
            hideLoading();
            message.success(`${setLeverageResult}. This change should be picked up by the system within 1 min.`, 5);
            ElAdminEventLogService.saveSetLeverageEvent(targetLeverage, actionDetails);
          } catch (error) {
            hideLoading();
            message.error(error.message ? error.message : String(error));
          }
        }}
        okText="Confirm"
        cancelText="Cancel"
      >
        <Button type="link">Update</Button>
      </Popconfirm>
    </Space>
  );
};

export default UpdateLeverageButton;
